import { render, staticRenderFns } from "./ClinicListCard.vue?vue&type=template&id=f86db0a8"
import script from "./ClinicListCard.vue?vue&type=script&lang=js"
export * from "./ClinicListCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports